<template>
  <job-status-chip :status="finalStatus"></job-status-chip>
</template>

<script setup lang="ts">
import JobStatusChip from '@/components/tickets/JobStatusChip.vue'
import { NO_APPROVAL, REQUESTED } from '@/models/job'
import { computed } from 'vue'
import { JobSearchResponse } from '@/models/types/job-search-response'
const props = withDefaults(
  defineProps<{
    value?: string
    job: JobSearchResponse
  }>(),
  {
    value: REQUESTED,
  },
)
const finalStatus = computed(() => {
  const approvalStatus = props.job.approval_status ?? NO_APPROVAL
  return approvalStatus !== NO_APPROVAL ? approvalStatus : props.value.trim()
})
</script>
